import React from "react";
import {Typography} from "@mui/material";
import Page from "../../../components/Layout/Page";
import {useTranslation} from "react-i18next";
import TabSection from "../../../components/Layout/Page/TabSection";
import DefaultFirmwares from "./Firmwares";

export default function SettingsDetailpage() {
    const {t} = useTranslation();
    return (
        <Page dataTest={"settingsPage"}>
            <Typography variant={"h2"} data-test="settingsPage.title">
                {t("generic_settings")}
            </Typography>
            <TabSection
                title={t("generic_firmwares")}
                tabs={[{label: t("generic_firmwares"), content: <DefaultFirmwares />}]}
                dataTest="settingsPage.firmwaresTabSection"
            />
        </Page>
    );
}
